/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Driver_DescInputs */

const vi_assign_driver_desc = /** @type {(inputs: Assign_Driver_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn tài xế sẽ nhận đơn này. Tài xế đang rảnh được xếp lên đầu danh sách.`)
};

/**

* @param {Assign_Driver_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_desc = /** @type {((inputs?: Assign_Driver_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_desc(inputs)
});